import { ReactNode } from "react";
import Content from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Content/Content";
import TopRow from "@coworker/apprestructured/src/task-management/components/TaskCard/components/TopRow/TopRow";
import BottomRow from "@coworker/apprestructured/src/task-management/components/TaskCard/components/BottomRow/BottomRow";
import Assigned from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Assigned/Assigned";
import TaskType from "@coworker/apprestructured/src/task-management/components/TaskCard/components/TaskType/TaskType";
import Date from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Date/Date";
import Priority from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Priority/Priority";
import {
  isLoading,
  Loading,
} from "@coworker/apprestructured/src/task-management/loading";

type PendingTaskCardProps = {
  children: ReactNode;
  taskType: string | Loading;
  date: string | Loading;
  assigned: string | Loading;
  priority: boolean | Loading;
};

function ClosedTaskCard({
  children,
  taskType,
  date,
  assigned,
  priority,
}: PendingTaskCardProps) {
  return (
    <Content>
      <TopRow>
        <TaskType value={taskType} />
        {priority && !isLoading(priority) && <Priority dim />}
      </TopRow>
      {children}
      <BottomRow>
        <Assigned value={assigned} />
        <Date value={date} />
      </BottomRow>
    </Content>
  );
}

export default ClosedTaskCard;
